import { events } from "@constants/tracking";
import Box from "@memorang/ui/components/Box";
import Container from "@memorang/ui/components/Container";
import { ChallengesHeader } from "@memorang/ui/components/Library/ChallengesHeader";
import ChallengesView from "@memorang/ui/components/Library/ChallengesView";
import FilterModalContainer from "@memorang/ui/components/Library/FilterModalContainer";
import SortModalContainer from "@memorang/ui/components/Library/SortModalContainer";
import { trackCustomEvent } from "analytics";
import { useCallback, useMemo } from "react";
import { SortButton } from "../components/SortButton";
import { sortItems } from "../constants";
import useLibrary from "../hooks/useLibrary";

const ChallengesListContainer = () => {
	const isPremiumUser = false;
	const {
		quickActionsChips,
		specialitiesFilter,
		filteredSections,
		handleChallengePress,
		searchQuery,
		isPremiumSelected,
		isCompletedSelected,
		clearAllFilters,
		applySpecialityFilters,
		numChallenges,
		numTotalChallenges,
		handleQuickActionChipPress,
		showFilterModal,
		showSortModal,
		setShowFilterModal,
		setShowSortModal,
		handleSortPress,
		sortType,
	} = useLibrary();

	const sections = useMemo(() => {
		return filteredSections();
	}, [filteredSections]);

	const handleQuickActionPress = useCallback(
		(type: string) => {
			if (type === "speciality") {
				setShowFilterModal(true);
			} else {
				handleQuickActionChipPress(type);
			}
		},
		[handleQuickActionChipPress, setShowFilterModal],
	);

	const handleCloseFilterModal = useCallback(() => {
		setShowFilterModal(false);
		trackCustomEvent({
			eventName: events.bottomSheetClosed,
			type: "filter",
			source: "challenges",
		});
	}, [setShowFilterModal]);

	const handleCloseSortModal = useCallback(() => {
		setShowSortModal(false);
		trackCustomEvent({
			eventName: events.bottomSheetClosed,
			type: "sort",
			source: "challenges",
		});
	}, [setShowSortModal]);

	return (
		<Container containerStyle={{ paddingTop: 16 }} maxWidth="sm">
			<ChallengesHeader
				numChallenges={numChallenges}
				quickActionsChips={quickActionsChips}
				onQuickActionPress={handleQuickActionPress}
				searchQuery={searchQuery}
				sortButton={<SortButton />}
			/>
			<Box paddingTop={8} paddingBottom={8}>
				<ChallengesView
					contentContainerStyle={{ paddingBottom: 200 }}
					sections={sections}
					handleChallengePress={handleChallengePress}
					handleClearFilters={clearAllFilters}
					isPremiumUser={isPremiumUser}
					activeFilters={{
						searchQuery,
						isPremiumSelected,
						isCompletedSelected,
					}}
					totalChallenges={numTotalChallenges}
					isCME={false}
				/>
			</Box>
			<SortModalContainer
				showModal={showSortModal}
				handleSheetClose={handleCloseSortModal}
				handleSelectSortItem={handleSortPress}
				sortItems={sortItems}
				currentSortType={sortType}
				onOpen={() =>
					trackCustomEvent({
						eventName: events.bottomSheetOpened,
						type: "sort",
						source: "challenges",
					})
				}
			/>
			<FilterModalContainer
				showModal={showFilterModal}
				handleSheetClose={handleCloseFilterModal}
				specialitiesFilter={specialitiesFilter}
				applyFilters={applySpecialityFilters}
				onOpen={() =>
					trackCustomEvent({
						eventName: events.bottomSheetOpened,
						type: "filter",
						source: "challenges",
					})
				}
			/>
		</Container>
	);
};

export default ChallengesListContainer;
